import React, { ChangeEvent } from 'react';
import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  RedAsterix,
} from '@wegroup/design-system';
import { useTranslation } from 'react-i18next';
import { InsuranceDetailFormValues } from '../../../../../types/Form';
import { useFieldArray, useFormContext } from 'react-hook-form';
import useRiskObjectInputStore from '@parties/src/features/risk-objects/store/riskObjectInputStore';

const InsuranceCompaniesInput: React.FC = () => {
  const { t } = useTranslation();
  const setFocusedInput = useRiskObjectInputStore(
    (state) => state.setFocusedInput,
  );
  const { fields, update } = useFieldArray<
    InsuranceDetailFormValues,
    'coverages'
  >({
    name: 'coverages',
  });
  const {
    register,
    formState: { errors },
  } = useFormContext<InsuranceDetailFormValues>();

  const { onChange, ...rest } = register('insurance_company', {
    onBlur: () => setFocusedInput(null),
  });

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.currentTarget.value;
    fields.forEach((field, i) => {
      update(i, { ...field, insurance_company: value });
    });
    onChange(e);
  };

  return (
    <FormControl isInvalid={!!errors.insurance_company}>
      <FormLabel>
        {t(`CARRIER`)} <RedAsterix />
      </FormLabel>
      <Input
        {...rest}
        onChange={handleChange}
        onFocus={() => setFocusedInput('insurance_company')}
      />
      {errors.insurance_company?.message && (
        <FormErrorMessage>
          {t(errors.insurance_company.message)}
        </FormErrorMessage>
      )}
    </FormControl>
  );
};

export default InsuranceCompaniesInput;
